var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cgs-worksheet-customPageContent"},[(Object.keys(_vm.gridItemConfig).length > 0)?_c('custom-page-content',{attrs:{"gridItemConfig":_vm.gridItemConfig,"staticGrid":true,"fullSceenAbled":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }